import {
  SUPERSET_TOTAL_CSAT_INVITES_SENT,
  SUPERSET_TOTAL_CSAT_INVITES_SENT_SUCCESS,
  SUPERSET_TOTAL_CSAT_INVITES_SENT_ERROR,
  SUPERSET_TOTAL_CSAT_INVITES_SENT_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetTotalCsatInvitesSent = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_TOTAL_CSAT_INVITES_SENT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_TOTAL_CSAT_INVITES_SENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_TOTAL_CSAT_INVITES_SENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_TOTAL_CSAT_INVITES_SENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetTotalCsatInvitesSent;
